"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var OptimizationConfigurations_service_1 = __importDefault(require("./Service/OptimizationConfigurations.service"));
var OptimizationConfigurationV2 = /** @class */ (function () {
    function OptimizationConfigurationV2(session) {
        this.optimizationConfigurationService = new OptimizationConfigurations_service_1.default(session);
    }
    OptimizationConfigurationV2.prototype.create = function (configuration) {
        return this.optimizationConfigurationService.create(configuration);
    };
    OptimizationConfigurationV2.prototype.list = function () {
        return this.optimizationConfigurationService.list();
    };
    OptimizationConfigurationV2.prototype.getById = function (id) {
        return this.optimizationConfigurationService.getById(id);
    };
    OptimizationConfigurationV2.prototype.update = function (id, configuration) {
        return this.optimizationConfigurationService.update(id, configuration);
    };
    OptimizationConfigurationV2.prototype.delete = function (id) {
        return this.optimizationConfigurationService.delete(id);
    };
    OptimizationConfigurationV2.prototype.batchDelete = function (configurationIds) {
        return this.optimizationConfigurationService.batchDelete(configurationIds);
    };
    OptimizationConfigurationV2.prototype.getMerchantTeamSettings = function () {
        return this.optimizationConfigurationService.getMerchantTeamSettings();
    };
    return OptimizationConfigurationV2;
}());
exports.default = OptimizationConfigurationV2;
//# sourceMappingURL=OptimizationConfigurationV2.js.map